import { openEnjoyApp } from '@/utils/appDetection';
import styled from 'styled-components';
import { Header, Logo, PlayButton } from '../vote/styles';

const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #FFF5E6 0%, #E6F5E6 100%);
  position: relative;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  margin-top: 80px; /* 为固定header留出空间 */
  
  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const ErrorCode = styled.div`
  color: #FA7C70;
  text-align: center;
  font-family: Inter;
  font-size: 160px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    font-size: 120px;
  }
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #2B2928;
  margin: 0 0 16px 0;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Message = styled.p`
  color: var(--Colour-90, rgba(0, 0, 0, 0.90));
  font-family: "SF UI Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0 0 32px 0;
  text-align: center;
  max-width: 500px;
  
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const BackButton = styled.button`
  display: flex;
  width: 180px;
  height: 40px;
  padding: 16px 26px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 24px;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 4px solid #000;
  border-left: 1px solid #000;
  background: #FFF;
  color: #2B2928;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f5f5f5;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const NotFound = () => {

  const handleBackHome = () => {
    window.location.href = 'https://enjoylabs.go.link/ljmcB';
  };

  const handlePlayClick = () => {
    openEnjoyApp();
  };

  return (
    <NotFoundContainer>
      <Header>
        <Logo>
          <div className="logo-icon"></div>
          <span>Enjoy - AI Town</span>
        </Logo>
        <PlayButton onClick={handlePlayClick}>PLAY</PlayButton>
      </Header>
      <Content>
        <ErrorCode>404</ErrorCode>
        <Title>Page not found</Title>
        <Message>
          Oops! The page you are looking for does not exist. It might have been moved or deleted.
        </Message>
        <BackButton onClick={handleBackHome}>
          Back to home
        </BackButton>
      </Content>
    </NotFoundContainer>
  );
};

export default NotFound;

